import { styled } from '@mui/material'
import Typography from '@mui/material/Typography'
import { COLORS } from '../../styles/colors'

export const TypographyPrimary16B = styled(Typography)(() => ({
	fontFamily: 'Montserrat',
	fontWeight: 500,
	fontStyle: 'normal',
	fontSize: '16px',
	lineHeight: '100%',
	letterSpacing: '0',
	verticalAlign: 'middle',
	color: COLORS.black,
}))
